import {Observable, of} from "rxjs";
import { ICommand } from "../../modules/records/commands/i-command";
import { IApiService } from "../../modules/records/models/api/i-api-service";
import { RecordsManager } from "../../modules/records/records-manager";
import {catchError, tap} from "rxjs/operators";
import {RecoveryPlanStatus} from "../../modules/pages/hot-alert/configurations/recovery-plan-status";

export class CreateRecoveryPlanCommand<
  T extends object & { disabled: boolean, rpStatus?: string, rpCreateBtn?: '0' | '1' },
  S extends IApiService<T> & {
    createRecoveryPlan: (el: T) => Observable<any>;
  }
> implements ICommand<T, S>
{
  private receiver!: RecordsManager<T>;
  type: "primary" | "warn" | "accent" = "accent";
  layout: "flat" | "raised" | "normal" | undefined = "raised";
  label = "CREATE";

  private isExecuting: boolean = false;

  constructor(public service: S) {}

  execute(el: T) {
    this.isExecuting = true;

    this.service.createRecoveryPlan(el).pipe(
      catchError(error => {
        return of({ success: false });
      }),
      tap(res => {
        if (res) {
          if (res.success) {
            this.receiver.onSuccess();
          } else {
            this.receiver.onError();
          }
        }
    })).subscribe(p => {
      this.isExecuting = false;
    });
  }

  setReceiver(receiver: RecordsManager<T>) {
    this.receiver = receiver;
  }

  isLoadingForElement(el: T){
    return this.isExecuting;
  }

  showLabelForElement(el: T){
    return this.isExecuting
  }

  isDisabled(el: T) {
    const status = (el?.rpStatus ?? '');
    this.label = status != '' && status != RecoveryPlanStatus.DELETE ? 'CREATED' : 'CREATE';
    return el.disabled || this.receiver.isLoading || this.isExecuting || status == RecoveryPlanStatus.CLOSE || status == RecoveryPlanStatus.OPEN;
  }

  isHidden(el: T) {
    const status = (el?.rpStatus ?? '');
    return el.disabled && (status == '' || status == RecoveryPlanStatus.DELETE);
  }
}
